exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.conver {\r\n    border: 1px solid;\r\n    border-radius: 8px;\r\n    padding: 5px;\n}\n.right {\r\n    text-align: right;\r\n    background: rgb(147 235 169);\n}\r\n", ""]);

// exports
